import { makeAutoObservable } from "mobx";
import type { ExistPhazeProductInterface } from "helpers/types";
import type { UsersCard } from "api/types/cardProduct";
class Store {
  giftCardsList: ExistPhazeProductInterface[] | null = null;
  cryptoCardsList: UsersCard[] | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setGiftCardsList = (giftCards: ExistPhazeProductInterface[]) => {
    this.giftCardsList = giftCards;
  };

  setCryptoCardsList = (cryptoCards: UsersCard[]) => {
    this.cryptoCardsList = cryptoCards;
  };

  clearCardsStore = () => {
    this.giftCardsList = null;
    this.cryptoCardsList = null;
  };
}

const cardsStore = new Store();
export default cardsStore;
